import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
  HEADLINE: {
    // textAlign: "center",
    fontSize: "28pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    // padding: "10px 0"
    paddingBottom: 10,
    // color: theme.foregroundColor
  },
  TEXT: {
    // textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "12pt",
    lineHeight: "18pt",
    padding: "10px 0",
    // color: theme.foregroundColor
  },
  BUTTON: {
    style: {
      display: "inline-block",
      textAlign: "center",
      padding: 15,
      border: "none",
      backgroundColor: theme.backgroundColor,
      minWidth: 150,
      marginTop: 25,
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "14pt",
    },
  },
  LIST: {
    padding: 5,
    margin: "0 auto",
    // marginTop: 20,
  },
  LI: {
    style: {
      // color: theme.foregroundColor,
      fontFamily: theme.fontFamily,
      padding: 5,
    },
    contentStyle: {
      padding: "3px 10px",
    },
    iconStyle: {
      marginTop: 5,
    },
  },
};
